import type React from "react"
import { motion } from "framer-motion"
import { Button } from "components/Button/Button"
import { Form, InputConfig } from "components/Form/Form"
import { Link, useNavigate } from "react-router-dom"
import { AppIcon } from "assets/app/app-icon"
import { useLangContext } from "context/Lang"
import { useEffect, useState } from "react"
import { AsyncProcess } from "services/AsyncProcess"
import { routes } from "routes"
import { useDispatch } from "react-redux"
import { setToast } from "storeRedux/slices/toast"
import { decodeJWT } from "utils/decodeJWT"
import { ToastMessage } from "primereact/toast"
import { Crypto } from "utils/Crypto"
import axios from "axios"
import { setUser } from "storeRedux/slices/authSlice"
import { isValidJSON } from "utils/isValidJSON"


type LoginForm = {
    userName: string,
    password: string,
    rememberMe: boolean,
    userType: string
}


type LoginProps={
    doNatRoute?:boolean
    onLogin?:()=>void
    className?:string

}

export const Login = ({doNatRoute,onLogin,className="min-h-screen"}:LoginProps) => {

    const { gW } = useLangContext();

    const [block, setBlock] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [remembermyData, setRemembermyData] = useState<LoginForm | null>(null)


    useEffect(() => {

        const tempData = Crypto({ proce: "decrypt", data: localStorage.getItem("rememberMe") + "" });
        if (isValidJSON(tempData)) {


            setRemembermyData({ ...JSON.parse(tempData), rememberMe: "true" })
        } else {
            localStorage.removeItem("rememberMe")
        }

    }, []);




    const Inputs: InputConfig<LoginForm>[] = [
        {
            type: "text",
            name: "userName",
            label: gW("username"),
            required: true
        },
        {
            type: "password",
            name: "password",
            label: gW("password"),
            required: true
        },
        {
            type: "select",
            name: "userType",
            label: gW("user-type"),
            required: true,
            options: [
                {
                    "label": gW("academic"),
                    "value": 1
                },
                {
                    "label": gW("student"),
                    "value": 2
                },
                // { 
                //     "label": gW("administrative"), 
                //     "value": 3 
                // },
                {
                    "label": gW("coordinator"),
                    "value": 4
                },
                { 
                    "label": gW("manager"), 
                    "value": 5 
                },
            ]
        },
        {
            type: "checkbox",
            name: "rememberMe",
            label: gW("remember-me")
        }
    ]

    const handleSubmit = (e: LoginForm) => {
        setBlock(true);
        AsyncProcess({
            type: "post",
            url: routes.api.login,
            data: e,
            setError: (err) => {

                setBlock(false)
                dispatch(setToast({ severity: err?.severity || "happen-error", detail: gW(err?.error, err?.words) } as ToastMessage))
            },


            effectProcess: [(res) => {




                if (res?.success === false) {
                    dispatch(setToast({ severity: "error", detail: gW(res?.message || "happen-error") } as ToastMessage))

                } else {
                    // const resData = res?.data;

                    const token = res?.data?.token;





                    const { user } = decodeJWT(token) as { user: UserType }




                    if (user?.userName === e?.userName) {
                        if (e?.rememberMe) {
                            localStorage.setItem("rememberMe", Crypto({
                                proce: "encrypt",
                                data: JSON.stringify({
                                    userName: e?.userName,
                                    password: e?.password,
                                    userType: e?.userType
                                })
                            }))
                        } else {
                            localStorage.removeItem("rememberMe")
                        }




                        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

                        dispatch(setUser({ token: token, user }))

                        dispatch(setToast({ severity: "success", detail: gW("login-sucessfully") } as ToastMessage))
                        onLogin?.();

                        !doNatRoute&&navigate(routes.dashboard);

                    } else {
                        dispatch(setToast({ severity: res?.severity, detail: gW(res?.message) } as ToastMessage))
                    }
                }

                setBlock(false);

            }]
        })
    }

    return (
        <div className={"flex  items-center justify-center bg-gradient-to-br from-background via-background to-primary/5 px-4 "+className }>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="w-full max-w-md"
            >

                <div>
                    <Form<LoginForm>
                        animate={true}
                        // defaultData={remembermyData||undefined}
                        data={remembermyData || undefined}
                        loading={block}
                        header={
                            <Link to="/" className="mb-8 flex items-center justify-center gap-2">
                                <motion.div className="flex items-center gap-2">
                                    <AppIcon className=" w-20 h-20 " />
                                    <span className="text-2xl font-bold"></span>
                                </motion.div>
                            </Link>
                        }
                        inputs={Inputs}
                        disabled={block}
                        submitTitle={gW("login-title")}
                        onSubmit={handleSubmit}
                    />
                </div>

            </motion.div>
        </div>
    )
}